var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"color":"red","size":"10"}},[_vm._v("mdi-asterisk")])}
var staticRenderFns = []

export { render, staticRenderFns }